import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { SelectType } from '~/components/NovosInputs/InputSelect/protocols';
import { tipoIPI } from '~/pages/Produto/constants';
import { useProduto } from '~/pages/Produto/hooks/useProduto';
import {
  InputMoney,
  InputPercent,
  InputSelect,
} from '~/components/NovosInputs';

export const AbaIpi: React.FC = () => {
  const {
    watch,
    register,
    control,
    setValue,
    formState: { errors },
    handleTipoIPI,
  } = useProduto();

  return (
    <>
      <Row>
        <Col sm={12} md={4} lg={2} xl={2}>
          <InputSelect
            label="Tipo de IPI"
            name="ipi_tipo"
            register={register}
            isError={!!errors.ipi_tipo}
            control={control}
            options={tipoIPI as SelectType[]}
            changeSelected={(selected) => {
              const { value } = selected;
              handleTipoIPI(value);
              setValue('ipi_tipo', selected);
              setValue('ipi_val', '0,00');
            }}
          />
        </Col>
        <Col sm={12} md={2} lg={2} xl={2}>
          {watch('ipi_tipo')?.value === 0 && (
            <InputPercent
              label="IPI Entrada"
              min={0}
              max={100}
              step="2"
              maxLength={5}
              placeholder="0,00"
              isDisabled={
                watch('ipi_tipo') === undefined ||
                watch('ipi_tipo')?.value === -1
              }
              name="ipi_val"
              register={register}
              control={control}
              isError={!!errors.ipi_val}
              showIcon
            />
          )}

          {watch('ipi_tipo')?.value === 1 && (
            <InputMoney
              label="IPI Entrada"
              min={0.01}
              placeholder="0,00"
              register={register}
              name="ipi_val"
              isError={!!errors.ipi_val}
              showIcon
              control={control}
            />
          )}
        </Col>
      </Row>
    </>
  );
};
